import React, { useContext, useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby';
import { StoreContext } from '../context/store-context';
import { getLocalStorage } from '../utils/helpers';

const Popup = () => {
    const [openPopup, setOpenPopup] = useState(false)
    const { setLightboxOpen, setLightboxContent } = useContext(StoreContext);
    const popupsQuery = useStaticQuery(graphql`
    query {
      allWpPopup {
        nodes {
            content
            status
            id
            popupOptions {
                delay
                targetPage {
                ... on WpPage {
                    id
                    slug
                    uri
                }
              }
          }
        }
      }
    }`)
    const popupList = popupsQuery.allWpPopup.nodes;
    useEffect(() => {
        const isBrowser = typeof window !== `undefined`
        let path = "";
        if (isBrowser) {
            path = window.location.pathname === '/' ? '/' : window.location.pathname.replaceAll('/', '')
        }
        if (!openPopup) {
            popupList.forEach(popup => {
                let delay = popup.popupOptions.delay ? popup.popupOptions.delay * 1000 : 1000;
                if (popup.status === 'publish' && !getLocalStorage(popup.id)) {
                    if (popup.popupOptions.targetPage) {
                        popup.popupOptions.targetPage.forEach(page => {
                            if ((page.slug === 'home' || page.uri === '/') && path === '/') {
                                setTimeout(() => {
                                    setOpenPopup(true)
                                    // setLightboxOpen(true);
                                    setLightboxContent(<div dangerouslySetInnerHTML={{__html: popup.content}} />)
                                    isBrowser && localStorage.setItem(popup.id, true)
                                }, delay);
                            } else if (path === page.slug) {
                                setTimeout(() => {
                                    setOpenPopup(true)
                                    // setLightboxOpen(true);
                                    setLightboxContent(<div dangerouslySetInnerHTML={{__html: popup.content}} />)
                                    isBrowser && localStorage.setItem(popup.id, true)
                                }, delay);
                            }
                        });
                    } else {
                        setTimeout(() => {
                            setOpenPopup(true)
                            // setLightboxOpen(true);
                            setLightboxContent(<div dangerouslySetInnerHTML={{__html: popup.content}} />)
                            isBrowser && localStorage.setItem(popup.id, true)
                        }, delay);
                    }
                }

            });
        }

    }, [openPopup,popupList,setLightboxContent,setLightboxOpen])

    return (
        <></>
    )
}

export default Popup